import * as React from 'react';
export const TableCell = ({ as = 'td', ...rest }) => {
    return React.createElement(as, {
        role: as !== 'td' ? 'cell' : undefined,
        ...rest,
    });
};
